import axios from "axios";
const jsonConfig = require("../../Config.json");

const createUserRequest = async (userDataRequest) => {
  let allResponse = {};
  try {
    const getallresponse = await axios.post(
      jsonConfig.apiUrl + "users",
      userDataRequest,
      {
        headers: {
          "x-functions-key": jsonConfig.key,
        },
      }
    );

    allResponse = getallresponse;

    return Promise.resolve(allResponse);
  }
  catch (error) {
    console.log("errrrrr", error);
    return Promise.reject(error);
  }
}

export default createUserRequest;